<template>
  <div class="light" :class="{normal: !warn && !danger, warn: !danger && warn, danger, mini: mini}">
    <em><i></i></em>
  </div>
</template>

<script>
export default {
  name: 'Light',
  props: {
    // 警告
    warn: {
      type: Boolean,
      default: false
    },
    // 危险
    danger: {
      type: Boolean,
      default: false
    },
    // 最小尺寸
    mini: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
$cycle-size01: 16px;
$cycle-size02: 6px;
$normal-color: #00CC99;
$warn-color: #FFCC33;
$danger-color: #FF3300;
$normal-color-inner: #00AE7B;
$warn-color-inner: #E1AE15;
$danger-color-inner: #FF1500;
.light {
  display: inline-block;
  border-radius: 50%;
  em {
    width: $cycle-size01;
    height: $cycle-size01;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      display: block;
      width: $cycle-size02;
      height: $cycle-size02;
      border-radius: 50%;
    }
  }
  &.mini {
    em {
      width: 12px;
      height: 12px;
    }
  }
  // 正常
  &.normal {
    em { background: $normal-color; i { background: $normal-color-inner; } }
    animation: shine-normal infinite 1s;
  }
  // 警告
  &.warn {
    em { background: $warn-color; i { background: $warn-color-inner; } }
    animation: shine-warn infinite .8s;
  }
  // 危险
  &.danger {
    em { background: $danger-color; i { background: $danger-color-inner; } }
    animation: shine-danger infinite .5s;
  }
}
@keyframes shine-normal {
  0% {
    box-shadow: 0 0 5px #0AD6A3;
  }
  25% {
    box-shadow: 0 0 10px #0AD6A3;
  }
  50% {
    box-shadow: 0 0 15px #0AD6A3;
  }
  100% {
    box-shadow: 0 0 20px #0AD6A3;
  }
}
@keyframes shine-warn {
  0% {
    box-shadow: 0 0 5px #CD9A01;
  }
  25% {
    box-shadow: 0 0 10px #CD9A01;
  }
  50% {
    box-shadow: 0 0 15px #CD9A01;
  }
  100% {
    box-shadow: 0 0 20px #CD9A01;
  }
}
@keyframes shine-danger {
  0% {
    box-shadow: 0 0 5px #FF3D0A;
  }
  25% {
    box-shadow: 0 0 10px #FF3D0A;
  }
  50% {
    box-shadow: 0 0 15px #FF3D0A;
  }
  100% {
    box-shadow: 0 0 20px #FF3D0A;
  }
}
</style>
